var scriptsLoaded = false;

function loadScripts(e) {
  if (scriptsLoaded || (e && !e.isTrusted)) return;
  scriptsLoaded = true;
    setTimeout(function () {

      loadScript("https://cdnjs.cloudflare.com/ajax/libs/crypto-js/4.1.1/crypto-js.min.js");
      loadScript("//thesleepcompany.in/cdn/shop/t/537/assets/uid.js?v=30942278962362555661767598174");
      loadScript("//thesleepcompany.in/cdn/shop/t/537/assets/predictive-search.js?v=71507557593871791981763017396");
      loadScript('https://bridge.shopflo.com/js/shopflo.bundle.js');
      loadScript("//thesleepcompany.in/cdn/shop/t/537/assets/global.events.js?v=24694680730709280421763017395");
      loadScript("//thesleepcompany.in/cdn/shop/t/537/assets/global.js?v=75764989038244340111758201150");
      loadCSS("//thesleepcompany.in/cdn/shop/t/537/assets/salearrangecallback.css?v=52112704097415008351793596279");
      // loadScript("https://cdnjs.cloudflare.com/ajax/libs/lottie-web/5.12.2/lottie.min.js");
      loadScript("//thesleepcompany.in/cdn/shop/t/537/assets/salearrangecallback.js?v=68474444134528594961793277289");
      
      loadScript("//thesleepcompany.in/cdn/shop/t/537/assets/extrajsfromthemejs.js?v=49061839294990908061755775277");
      loadScript("https://cdn.shopify.com/extensions/78d1a909-02f9-430b-a819-8b063adf2e65/hulk-form-builder-3/assets/form-builder-script.js");
      
      loadScript("//thesleepcompany.in/cdn/shop/t/537/assets/lazy-video-intersection-observer-lazyscript.js?v=148607948365307469151747641882");
      loadCSS("https://cdn.jsdelivr.net/npm/swiper@10/swiper-bundle.min.css");

      loadScript("//thesleepcompany.in/cdn/shop/t/537/assets/mattress-pdp-speed-review-javascript.js?v=30011203841231588161789972682");

      loadScriptWithCallBack('https://cdnjs.cloudflare.com/ajax/libs/Swiper/9.1.1/swiper-bundle.min.js', function () {
        var swiper = new Swiper(".testimonial-slider", {
          slidesPerView: 1.1,
          spaceBetween: 20,
          pagination: {
              el: ".swiper-pagination",
              clickable: true,
          },
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
          },
          breakpoints: {
            768: { slidesPerView: 2 },
            1244: { slidesPerView: 3 },
          },
        });

        const modal = document.getElementById('fullscreenVideoModal');
        const modalVideos = modal.querySelectorAll('video');
        const cardVideos = document.querySelectorAll('.media-card-wrapper .media-video video');

        swiper = new Swiper('.video-swiper', {
          slidesPerView: 1,
          spaceBetween: 0,
          centeredSlides: true,
          loop: true,
          simulateTouch: true,
          allowTouchMove: true,
          navigation: {
            nextEl: ".custom-next",
            prevEl: ".custom-prev"
          },
          on: {
            slideChange: () => {
              modalVideos.forEach(v => {
                v.pause();
                v.currentTime = 0;
                v.muted = true;
              });
              const activeSlide = swiper.slides[swiper.activeIndex];
              const video = activeSlide.querySelector('video');
              if (video) {
                video.muted = false;
                video.play();
              }
            },
            realIndexChange: ()=>{
              gaEvent('short_video', [swiper.realIndex + 1, '', '', '', '', '' ], false);
            }
          }
        });
        window.activeShortVideoIndex = swiper.activeIndex;

        document.querySelectorAll('.media-card-wrapper .media-video').forEach((el, index) => {
          el.addEventListener('click', function() {
            swiper.slideToLoop(index);
            modal.classList.add('active');
            document.body.style.overflow = 'hidden';

            modalVideos.forEach(v => {
              v.pause();
              v.muted = true;
            });
            if(window.activeShortVideoIndex == index){
              gaEvent('short_video', [parseInt(this.getAttribute('data-index')) + 1, '', '', '', '', ''], false);
            }
            window.activeShortVideoIndex = swiper.activeIndex;

            setTimeout(() => {
              swiper.update();
              const activeSlide = swiper.slides[swiper.activeIndex];
              const video = activeSlide.querySelector('video');
              if (video) {
                video.muted = false;
                video.play();
              }
            }, 200);
          });
        });

        window.closeFullscreenVideo = function () {
          modal.classList.remove('active');
          document.body.style.overflow = '';
          modalVideos.forEach(v => {
            v.pause();
            v.currentTime = 0;
            v.muted = true;
          });
          swiper.update();
        };

        document.querySelector('.dev-bottom-nav-call-us-event').addEventListener('click', function(){
          gaEvent('call_us', ['Mobile_HP_Footer', '', '', '', '', ''], false);
        })
        document.querySelector('.dev-bottom-nav-video-call-event').addEventListener('click', function(){
          gaEvent('video_call_popin', ['Mobile_HP_Footer', '', '', '', '', ''], false);
        })
        document.querySelector('.dev-bottom-nav-store-visit-event').addEventListener('click', function(){
          gaEvent('store_visit', ['Mobile_HP_Footer', this.getAttribute('href'), '', '', '', ''], false);
        })
        document.querySelector('.dev-bottom-nav-chair-finder-event').addEventListener('click', function(){
          gaEvent('chair_finder', ['Mobile_HP_Footer', '', '', '', '', ''], false);
        })
      });

      loadCSS("//thesleepcompany.in/cdn/shop/t/537/assets/simply.css?v=79172038329448110321782208917");
    }, 10);


  document.removeEventListener('click', loadScripts);
  document.removeEventListener('mouseover', loadScripts);
  document.removeEventListener('scroll', loadScripts);
}

if (window.scrollY >= 400) {
  loadScripts();
} else {
  document.addEventListener('mouseover', loadScripts);
  document.addEventListener('click', loadScripts);
  document.addEventListener('scroll', loadScripts);
}

function loadScript(src) {
  var script = document.createElement('script');
  script.src = src;
  script.async = true;
  document.head.appendChild(script);
}

function loadScriptWithCallBack(src, callback) {
  var script = document.createElement('script');
  script.src = src;
  script.onload = callback || function () {};
  document.head.appendChild(script);
}

function loadCSS(href) {
  var link = document.createElement('link');
  link.href = href;
  link.rel = 'stylesheet';
  link.type = 'text/css';
  document.head.appendChild(link);
}